import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { formatDate, Location } from '@angular/common';
import { Utils } from 'src/app/utils/utils';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { Candidatura } from 'src/app/models/candidatura.model';
import { CandidaturaService } from 'src/app/services/candidatura.service';

declare var window: any;
@Component({
  selector: 'app-candidaturas',
  templateUrl: './candidatura.component.html',
  styleUrls: ['./candidatura.component.css']
})
export class CandidaturaComponent implements OnInit {
  generalMaskDate = "00/00/0000";
  candidatura = new Candidatura();
  idCandidatura: any;
  formCandidatura: FormGroup;
  token: string;
  idEleicao: any;
  isSubmit: boolean = false;
  resposta: any;
  editando: boolean = false;
  eleicaoParametrizando: any;
  editavelDataFimCandidaturas: string;
  editavelDataInicioCandidaturas: string;
  editavelDataFimAprovacao: string;
  editavelDataInicioAprovacao: string;
  btOff: boolean = false;


  constructor(
    protected messageService: MessageService,
    protected candidaturaService: CandidaturaService,
    protected formBuilder: FormBuilder,
    public utils: Utils,


  ) { }

  async ngOnInit() {
    this.eleicaoParametrizando = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao"));
    this.idEleicao = this.eleicaoParametrizando.id;
    this.token = sessionStorage.getItem("token");
    this.formCandidatura = new FormGroup({
      dataHoraInicioCandidaturas: new FormControl(),
      dataHoraFimCandidaturas: new FormControl(),
      dataHoraInicioAprovacao: new FormControl(),
      dataHoraFimAprovacao: new FormControl(),
    })
    this.formCandidatura = this.formBuilder.group({
      dataHoraInicioCandidaturas: ['', Validators.required],
      dataHoraFimCandidaturas: ['', Validators.required],
      dataHoraInicioAprovacao: ['', Validators.required],
      dataHoraFimAprovacao: ['', Validators.required]
    });

    if (sessionStorage.getItem("temCandidaturas")) {
      await this.listarDadosExistentes();
    } else {
      this.formCandidatura.disable();
      this.btOff = true;
    }


  }

  async listarDadosExistentes() {
    await this.candidaturaService.listarPorIdEleicao(this.idEleicao, this.token = sessionStorage.getItem("token")).then((data: any) => {
      this.editando = true;
      this.candidatura = data;
      this.formCandidatura.patchValue(data);
      this.idCandidatura = data.id;
      if(this.candidatura.qtAprovadoresDeferimento!=null){
        sessionStorage.setItem("qtAprovadores", String(this.candidatura.qtAprovadoresDeferimento));
      }
      if (this.editando == true) {
        this.editavelDataFimCandidaturas = formatDate(this.candidatura.dataHoraFimCandidaturas, 'yyyy-MM-ddTHH:mm', 'en-US');
        this.editavelDataInicioCandidaturas = formatDate(this.candidatura.dataHoraInicioCandidaturas, 'yyyy-MM-ddTHH:mm', 'en-US');
        this.editavelDataFimAprovacao = formatDate(this.candidatura.dataHoraFimAprovacao, 'yyyy-MM-ddTHH:mm', 'en-US');
        this.editavelDataInicioAprovacao = formatDate(this.candidatura.dataHoraInicioAprovacao, 'yyyy-MM-ddTHH:mm', 'en-US');
        this.formCandidatura.get("dataHoraInicioCandidaturas").patchValue(this.editavelDataInicioCandidaturas);
        this.formCandidatura.get("dataHoraFimCandidaturas").patchValue(this.editavelDataFimCandidaturas);
        this.formCandidatura.get("dataHoraInicioAprovacao").patchValue(this.editavelDataInicioAprovacao);
        this.formCandidatura.get("dataHoraFimAprovacao").patchValue(this.editavelDataFimAprovacao);
      }
    }, err => {
      console.log(err);
    })
  }

  public onSubmit() {
    this.candidatura.dataHoraInicioCandidaturas = this.formCandidatura.get('dataHoraInicioCandidaturas').value;
    this.candidatura.dataHoraFimCandidaturas = this.formCandidatura.get('dataHoraFimCandidaturas').value;
    this.candidatura.dataHoraInicioAprovacao = this.formCandidatura.get('dataHoraInicioAprovacao').value;
    this.candidatura.dataHoraFimAprovacao = this.formCandidatura.get('dataHoraFimAprovacao').value;
    this.candidatura.eleicao = { "id": this.idEleicao };
    if (!this.formCandidatura.valid
      || !this.validaData()
      || !this.validaData(new Date(this.candidatura.dataHoraFimCandidaturas))
      || !this.validaData(new Date(this.candidatura.dataHoraInicioCandidaturas))
      || !this.validaData(new Date(this.candidatura.dataHoraFimAprovacao))
      || !this.validaData(new Date(this.candidatura.dataHoraInicioAprovacao))
      || !this.validaAprovacaoAposCandidatura()
      || !this.validaAprovacaoAntesEleicao()) {
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Corrija o(s) erro(s) apontado(s) no formulário!" })
    }



    this.token = sessionStorage.getItem('token');
    if (this.editando == false) {
      this.btOff = true;
      document.body.style.cursor = 'wait';
      this.candidaturaService.salvarCandidatura(this.candidatura, this.token).then((data: Candidatura) => {
        this.resposta = data;
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Atenção', detail: "Dados da Candidatura inseridos com sucesso" });
        setTimeout(function () {
          document.body.style.cursor = 'default';
          sessionStorage.removeItem("eleicaoClicadaParametrizacao");
          window.history.back();
        }, 1200)//redirect backwards da página pra depois do aviso 
      }, error => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: error });
        console.log("error", error);
        this.btOff = false;
        document.body.style.cursor = 'default';
      });
    } else {
      this.btOff = true;
      document.body.style.cursor = 'wait';
      this.candidaturaService.editarCandidatura(this.idCandidatura, this.candidatura, this.token,).then((data: Candidatura) => {
        this.resposta = data;
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Atenção', detail: "Candidatura editada com sucesso!" });
        setTimeout(function () {
          document.body.style.cursor = 'default';
          window.location.reload();
        }, 1200)
      }, error => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: error });
        console.log("error", error);
        this.btOff = false;
        document.body.style.cursor = 'default';
      });
    }
  }

  // valida se data inicio e data fim é superior a data atual
  public validaData(date?: Date) {
    if (date) {
      var now = moment();
      return moment(date).isAfter(now) ? true : false;
    } else {
      var dataHoraInicioCandidaturas = this.formCandidatura.get('dataHoraInicioCandidaturas').value;
      var dataHoraFimCandidaturas = this.formCandidatura.get('dataHoraFimCandidaturas').value;
      if (dataHoraInicioCandidaturas && dataHoraFimCandidaturas) {
        return moment(dataHoraFimCandidaturas).isAfter(moment(dataHoraInicioCandidaturas)) ? true : false;
      }
      return false;
    }
  }

  public validaDataAprovacao() {
    var dataHoraInicioAprovacao = this.formCandidatura.get('dataHoraInicioAprovacao').value;
    var dataHoraFimAprovacao = this.formCandidatura.get('dataHoraFimAprovacao').value;
    if (dataHoraInicioAprovacao && dataHoraFimAprovacao) {
      return moment(dataHoraFimAprovacao).isAfter(moment(dataHoraInicioAprovacao));
    }
    return false;
  }

  public validaAprovacaoAposCandidatura() {
    var dataHoraFimCandidaturas = this.formCandidatura.get('dataHoraFimCandidaturas').value;
    var dataHoraInicioAprovacao = this.formCandidatura.get('dataHoraInicioAprovacao').value;
    if (dataHoraInicioAprovacao && dataHoraFimCandidaturas) {
      return moment(dataHoraInicioAprovacao).isAfter(moment(dataHoraFimCandidaturas));
    }
    return false;
  }

  public validaAprovacaoAntesEleicao(){
    var inicioEleicao = formatDate(this.eleicaoParametrizando.dataHoraInicio, 'yyyy-MM-ddTHH:mm', 'en-US');
    var dataHoraFimAprovacao = this.formCandidatura.get('dataHoraFimAprovacao').value;
    return !moment(inicioEleicao).isBefore(moment(dataHoraFimAprovacao));
  }

}